module.exports = __webpack_public_path__ + "img/fitness-image.61ef470c.png";